export default __webpack_public_path__ + "static/media/e.2fc76c54.jpg";